export const breadcrumbs = {
  attributeTagging: [{ name: "shoppe", to: "/" }, { name: "products", to: "/products" }],
  categoryRules: [{ name: "shoppe", to: "/" }, { name: "category rules", to: "/category-rules" }],
  rooms: [{name: "shoppe", to: "/"}, { name: "products", to: "/rooms" }]
}
